import { MESSAGES_EVENTS } from '@/config/config';
import socket from '../../../socket';

export default async (_, { payload, to }) => {
  if (to === 'consumer') {
    socket.emit(MESSAGES_EVENTS.CONSUMER_PRIVATE_MESSAGE, payload);
  } else {
    socket.emit(MESSAGES_EVENTS.PRIVATE_MESSAGE, payload);
  }
};
